export default function PHP_in_array() {
  return (
    <div>
      <h1>PHP_in_array</h1>
    </div>
  );
}
